import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

const { ppz, seller } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	ppz,
	seller,
	ppzSellerIn: 'ppzSellerIn',
	sellerSellerIn: 'sellerSellerIn',
};
